export const SupportedTenants = {
  development: [
    {
      name: "Jack & Jones",
      id: "aa8294bb-63fa-41dd-9a4a-37859f6ffc23",
      logoUrl:
        "https://dev.touchtech.com/assets/aa8294bb-63fa-41dd-9a4a-37859f6ffc23/e8c553ee-42a0-40f7-b6cd-68f77fa0c327.svg",
    },
    {
      name: "Vero Moda",
      id: "732472f3-a14f-4bf8-b8a2-770ee16f4288",
      logoUrl:
        "https://dev.touchtech.com/assets/732472f3-a14f-4bf8-b8a2-770ee16f4288/logo.svg",
    },
    {
      name: "Name It",
      id: "91e28e4c-8ad5-4806-ad17-90b05a92d2e9",
      logoUrl:
        "https://dev.touchtech.com/assets/91e28e4c-8ad5-4806-ad17-90b05a92d2e9/logo.svg",
    },
    {
      name: "VILA",
      id: "88efbd75-2efb-444a-990c-86bfe12dc140",
      logoUrl:
        "https://dev.touchtech.com/assets/88efbd75-2efb-444a-990c-86bfe12dc140/68564805-8daf-4b4e-8d07-62046fbfb5cc.svg",
    },
    {
      name: "Selected",
      id: "d02bc34f-dc8f-4f54-ab54-1c1ceefb5fdc",
      logoUrl:
        "https://dev.touchtech.com/assets/d02bc34f-dc8f-4f54-ab54-1c1ceefb5fdc/logo.svg",
    },
    {
      name: "Pieces",
      id: "a046e161-bca3-42a7-a9d0-d54e36a79fe0",
      logoUrl: "https://dev.touchtech.com/assets/default-logo.svg",
    },
  ],

  test: [
    {
      name: "Jack & Jones",
      id: "0f0ca69e-3b26-4573-83d2-161ea4f5d9d7",
      logoUrl:
        "https://test.touchtech.com/assets/0f0ca69e-3b26-4573-83d2-161ea4f5d9d7/4ba54a63-f2e8-443a-93a2-513ed291e5a5.svg",
    },
    {
      name: "VILA",
      id: "27ae39b5-4c69-4f40-8948-27a8c8e3073d",
      logoUrl:
        "https://test.touchtech.com/assets/27ae39b5-4c69-4f40-8948-27a8c8e3073d/logo.svg",
    },
    {
      name: "Vero Moda",
      id: "c7b1c5c8-5520-48e9-855c-50c19fc519e8",
      logoUrl:
        "https://test.touchtech.com/assets/c7b1c5c8-5520-48e9-855c-50c19fc519e8/logo.svg",
    },
    {
      name: "Name It",
      id: "8944957f-56dc-44a7-87c1-a2093e62fa6e",
      logoUrl:
        "https://test.touchtech.com/assets/8944957f-56dc-44a7-87c1-a2093e62fa6e/logo.svg",
    },
    {
      name: "Selected",
      id: "322e5a84-ab0c-454e-aec6-d635f5c89b86",
      logoUrl:
        "https://test.touchtech.com/assets/322e5a84-ab0c-454e-aec6-d635f5c89b86/logo.svg",
    },
    {
      name: "Pieces",
      id: "03d92b46-46ab-4058-8c99-b7cbdf715c25",
      logoUrl:
        "https://test.touchtech.com/assets/03d92b46-46ab-4058-8c99-b7cbdf715c25/d89d0e90-3114-42af-8424-fbe29c27b982.svg",
    },
  ],

  production: [
    {
      name: "Jack & Jones",
      id: "0a312b5a-b469-406a-956a-c67b597c5331",
      logoUrl:
        "https://app.touchtech.com/assets/0a312b5a-b469-406a-956a-c67b597c5331/a8e63fb7-6653-40f2-ab78-98add0cd6ae7.svg",
    },
    {
      name: "VILA",
      id: "d176c2d4-3a96-4791-96ed-b7b369f2060f",
      logoUrl:
        "https://app.touchtech.com/assets/d176c2d4-3a96-4791-96ed-b7b369f2060f/logo.svg",
    },
    {
      name: "Vero Moda",
      id: "e0bb6d22-c748-40a9-bb50-502f7d6ec01f",
      logoUrl:
        "https://app.touchtech.com/assets/e0bb6d22-c748-40a9-bb50-502f7d6ec01f/logo.svg",
    },
    {
      name: "Name It",
      id: "06ff15f0-d3b8-4b37-ae77-b1682e72a32b",
      logoUrl:
        "https://app.touchtech.com/assets/06ff15f0-d3b8-4b37-ae77-b1682e72a32b/logo.svg",
    },
    {
      name: "Selected",
      id: "aece3b76-ce14-4701-9fa1-57328456c084",
      logoUrl:
        "https://app.touchtech.com/assets/aece3b76-ce14-4701-9fa1-57328456c084/logo.svg",
    },
    {
      name: "JJXX",
      id: "bd70837b-7892-45f7-950a-faaf673d9a5e",
      logoUrl:
        "https://app.touchtech.com/assets/bd70837b-7892-45f7-950a-faaf673d9a5e/000f8fa0-8fcd-428d-bfc5-95a7b3a842e5.svg",
    },
    {
      name: "JJ-JJXX",
      id: "aae7615d-204e-4851-9adb-2179c33daa45",
      logoUrl:
        "https://app.touchtech.com/assets/aae7615d-204e-4851-9adb-2179c33daa45/51399747-a8ff-426a-91af-3e3bdbb17fd5.svg",
    },
    {
      name: "JACK&JONES Kids",
      id: "b461d3ca-a941-48a5-b669-46994c3804a2",
      logoUrl:
        "https://app.touchtech.com/assets/b461d3ca-a941-48a5-b669-46994c3804a2/85203764-8561-423f-9911-9693e7a48b55.svg",
    },
    {
      name: "Pieces",
      id: "820cea30-c632-47b4-a08d-df2daf687eb2",
      logoUrl:
        "https://app.touchtech.com/assets/820cea30-c632-47b4-a08d-df2daf687eb2/0704f968-3afe-4f56-b689-043940cf9412.svg",
    },
  ],
};
